import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import GuidHeaderDetails from '../../organizer/orgGuidDetails/guidHeaderDetails/GuidHeaderDetails';
import DetailsImageDisplay from '../../../components/detailsImageDisplay/DetailsImageDisplay';
import DetailsTab from '../../../components/orgDetails/detailsTab/DetailsTab';
import OrgDateTab from '../../../components/orgDetails/orgDateTab/OrgDateTab';
import styles from './supOrgGuideDetails.module.css';
import { fetchPackData } from '../supOrgTripDetailsFun/fetchSupOrgTripData';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { supAddTimeSlot, unavailableDateFun } from '../../../api/supportAdmin';
import OrgSlotTab from '../supOrgActivityDetails/actSlotAdd/ActSlotTab';

const MODE_TO_SERVICE = {
    t: 'trip',
    a: 'act',
    c: 'camp',
    g: 'gu'
};

const MODE_TO_SERVICE1 = {
    t: 'trip',
    a: 'activity',
    c: 'camp',
    g: 'guide'
};

const SupOrgGuideDetails = () => {
    const navigate = useNavigate();
    const { mode, orgId } = useParams();
    const location = useLocation();
    const guideId = location.pathname.split('/').pop();
    const [loading, setLoading] = useState(false);
    const [guidData, setGuidData] = useState({});
    const [load, setLoad] = useState(false);
    const [unAvailableDate, setUnAvailableDate] = useState(null);
    const serviceType = MODE_TO_SERVICE[mode] || 'guide';
    const [dateToDelete, setDateToDelete] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);

    const refresh = () => {
        setLoad(!load);
    };

    const context = {
        role: 'support',
        flow: MODE_TO_SERVICE1[mode]
    };

    useEffect(() => {
        fetchPackData(guideId, setLoading, setGuidData, serviceType);
    }, [load]);

    const addUnavailableDate = async (option) => {
        if (!unAvailableDate) {
            toast.error('Please select unavailable date');
            return;
        }
        setLoading(true);
        const unavailableDate = unAvailableDate.toISOString();
        try {
            const newDate = await unavailableDateFun(serviceType, option, {
                tourId: guideId,
                date: unavailableDate
            });
            if (newDate.status === 200) {
                toast.success('Successfully added new date');
                setUnAvailableDate(null);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            errorHandle(error);
            setLoading(false);
        }
    };

    const deleteUnavailableDate = async () => {
        try {
            setLoading(true);
            const response = await unavailableDateFun(serviceType, 'remove', { tourId: guideId, date: dateToDelete });
            if (response.status === 200) {
                setLoading(false);
                toast.success('Date deleted successfully');
                setDeleteModal(false);
                refresh();
            }
        } catch (err) {
            setLoading(false);
            errorHandle(err);
        }
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate(`/support/${mode}/packages/${orgId}`)}>
                <img src={BackIcon} alt='back' /> Back to Guides
            </button>
            {Object.keys(guidData).length !== 0 && (
                <div className='orgTripDetailsLayout'>
                    <div className='tripDetailsMainRow'>
                        <div className='tripDetailsLeft'>
                            <GuidHeaderDetails guidData={guidData} />
                            <DetailsImageDisplay imageData={guidData?.images || []} />
                            <DetailsTab
                                context={context}
                                data={guidData}
                                whichSection={'support'}
                                deleteUnavailableDate={deleteUnavailableDate}
                                setDateToDelete={setDateToDelete}
                                deleteModal={deleteModal}
                                setDeleteModal={setDeleteModal}
                                loading={loading}
                                refresh={refresh}
                            />
                        </div>
                        <div className='tripDetailsBookingUser'>
                            <OrgSlotTab
                                data={guidData}
                                type={serviceType}
                                addTimeSlot={supAddTimeSlot}
                                refresh={refresh}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SupOrgGuideDetails;
